import React, { Component } from "react";
import "../App.css";
import ScrollTrigger from "react-scroll-trigger";

class ReadTimer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      elapsedTime: null,
      numOfBooks: 0,
      wordsPerMinute: 0,
      daysToComplete: 0,
    };

    this.countUp = this.countUp.bind(this);
  }
  onEnterViewport = () => {
    this.componentWillUnmount();
    this.bookCounter();
    this.wordsPerMinuteCalc();
    this.daysToCompleteCounter();
  };

  countUp() {
    this.setState(({ elapsedTime }) => ({ elapsedTime: elapsedTime + 1 }));
  }
  componentDidMount() {
    this.interval = setInterval(() => this.countUp(), 1000);

    this.bookCountInterval = setInterval(() => this.bookCounter(), 1000);
  }

  componentWillUnmount = () => {
    clearInterval(this.interval);
    clearInterval(this.bookCountInterval);
  };

  wordsPerMinuteCalc = () => {
    this.setState(({ wordsPerMinute }) => ({
      wordsPerMinute: Math.round((231 / this.state.elapsedTime) * 60),
    }));
  };

  bookCounter = () => {
    if (this.state.elapsedTime > 2) {
      this.setState(({ numOfBooks }) => ({ numOfBooks: numOfBooks + 1 }));
    }
  };

  daysToCompleteCounter = () => {
    this.setState(({ daysToComplete }) => ({
      daysToComplete: Math.round(50000 / this.state.wordsPerMinute / 20),
    }));
  };
  render() {
    return (
      <ScrollTrigger onEnter={this.onEnterViewport}>
        <div className="read-timer-wrapper" id="timer">
          <h2 className="timer-text-body">
            You read the <span className="timer-text-number">231</span> words on
            this webpage in{" "}
            <span className="timer-text-number">{this.state.elapsedTime}</span>{" "}
            seconds.
          </h2>
          <h2 className="timer-text-body">
            That's{" "}
            <span className="timer-text-number">
              {this.state.wordsPerMinute}
            </span>{" "}
            words per minute!
          </h2>
          <h2 className="timer-text-body">
            If you read <span className="timer-text-number">20</span> minutes
            per day
          </h2>
          <h2 className="timer-text-body-bold">
            You'd finish a <span className="timer-text-number">200</span> page
            book in{" "}
            <span className="timer-text-number">
              {this.state.daysToComplete} days!
            </span>
          </h2>
        </div>
      </ScrollTrigger>
    );
  }
}

export default ReadTimer;
